import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './FieldLegend.css'

let fieldLegendId = 0

/**
 * Field Legend labels a [Field Set](/components/field-set/), naming the group of
 * fields for assistive technology. Place it as the first child of a Field Set.
 *
 * @status draft
 * @category form
 * @lightDom true
 *
 * @slot - Default slot for the legend text.
 */
@customElement('nord-field-legend')
export default class FieldLegend extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)

    // A stable id lets the enclosing Field Set reference it via aria-labelledby.
    if (!this.id) {
      this.id = `n-field-legend-${fieldLegendId++}`
    }
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-field-legend': FieldLegend
  }
}
